/**
 * What an "Always" reply allows from then on — the ONE answer for a live reply
 * (PermissionService) and a resumed one (`turnPermissionState`).
 *
 * Every permission allows its whole kind (`pattern: '*'`) — except bash, which
 * offers no "Always" at all (Season, 2026-10-30). bash asks only for a command
 * `isDangerousCommand` flags (tools/bash.ts — `rm -rf /`, a fork bomb, `dd` onto a
 * device), and no stored form of one holds: a wildcard allows every later
 * dangerous command, and even an exact text match was dodged three review rounds
 * running (a variable, a glob, `xargs`). So a dangerous command is asked every
 * time, and its card offers only Allow / Deny (`alwaysOffered: false`).
 *
 * Stored rules are judged by the same test when read back (`isGrantableRule`):
 * an earlier build may have stored `{ bash, '*' }` or an exact command.
 */
import type { Permission } from './permission.js'

const NO_ALWAYS: ReadonlySet<string> = new Set(['bash'])

export function alwaysGrantRules(permission: string): Permission.Ruleset {
  return NO_ALWAYS.has(permission) ? [] : [{ permission, pattern: '*', action: 'allow' }]
}

/** Whether a stored allow rule is one `alwaysGrantRules` could have produced. */
export function isGrantableRule(rule: Permission.Rule): boolean {
  return !NO_ALWAYS.has(rule.permission)
}
